export default "__VITE_ASSET__082595de__"